import { AppBar, Box, Tab, Tabs, Typography, useTheme } from '@mui/material';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ClusterConfigPage from './ClusterConfigPage';
import ClusterResultPage from './ClusterResultPage';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const ClusterConfigResultParentPage = ({ fetchedHeader }) => {
  const theme = useTheme();
  const [value, setValue] = useState(0);
  console.log("fetchedHeader1", fetchedHeader)

  const handleChange = (event, newValue) => {
    console.log("newValue", newValue)
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="white"
            textColor="white"
            variant="fullWidth"
            aria-label="full width tabs example"
            sx={{
              color: '#000',
              '& button': { backgroundColor: '#eee' },
              '& button:focus': { color: 'white', backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)' },
              '& button.Mui-selected': {
                color: 'white',
                backgroundImage: 'linear-gradient(to right, #4880EC, #019CAD)',
              },
            }}
          >
            <Tab label="Config" {...a11yProps(0)} />
            <Tab label="Result" {...a11yProps(1)} />
          </Tabs>
        </AppBar>
        <>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Box sx={{ width: '100%', height: '100%' }}>
              <ClusterConfigPage fetchedHeader={fetchedHeader} />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Box sx={{ width: '100%', height: '100%', backgroundColor: 'red'}}>
              <ClusterResultPage />
            </Box>
          </TabPanel>
        </>
      </Box>
    </Box>
  );
};

export default ClusterConfigResultParentPage;
